
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","viewBox":"0 0 20 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 4C6 3.44772 6.44772 3 7 3H9C9.55228 3 10 3.44772 10 4C10 4.55228 9.55228 5 9 5H7C6.44772 5 6 4.55228 6 4Z","fill":"#8E97A6"}}),_c('path',{attrs:{"d":"M7 6C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8H13C13.5523 8 14 7.55228 14 7C14 6.44772 13.5523 6 13 6H7Z","fill":"#8E97A6"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3 2C3 0.89543 3.89543 0 5 0H15C16.1046 0 17 0.895431 17 2V4.60592L19.0429 5.85436C19.6374 6.21767 20 6.86419 20 7.56093V17.0001C20 18.1047 19.1046 19.0001 18 19.0001H2C0.895432 19.0001 0 18.1047 0 17.0001V7.56093C0 6.86419 0.362591 6.21767 0.9571 5.85436L3 4.60592V2ZM17 7.61247V6.94982L17.7016 7.37859L17 7.61247ZM15 2V8.27913L9.99982 9.94586L5 8.27925V2H15ZM3 6.94982V7.61259L2.29824 7.37867L3 6.94982ZM18 9.38732L10.6323 11.8432C10.2217 11.9801 9.7779 11.9801 9.36737 11.8432L2 9.38744V17.0001H18V9.38732Z","fill":"currentColor"}})])
          )
        }
      }
    